<template>
<div>
  <columns>
    <column>
      <h4 class="is-size-5">TLS Certificate</h4>
    </column>
    <column class="is-narrow">
      <span class="tag" :class="{
          'is-success': cert.final_score === 100,
          'is-warning': cert.final_score < 100,
          'is-danger': cert.final_score < 90
        }">
        <span class="is-size-5 has-text-weight-bold">{{ cert.overall_grade }}</span>
      </span>
    </column>
  </columns>
  <columns>
    <column>
      <p class="is-flex justify-between mb">
        <span>Final Score </span> <span>{{ cert.final_score }}</span>
      </p>
      <p class="is-flex justify-between mb">
        <span>Cipher Strength Score </span> <span>{{ cert.cipher_strength_score }}</span>
      </p>
      <p class="is-flex justify-between mb">
        <span>Issuer </span> <span>{{ cert.issuer }}</span>
      </p>
      <p class="is-flex justify-between mb">
        <span>Expiration </span> <span>{{ cert.cert_expiration }}</span>
      </p>
      <p class="is-flex justify-between mb">
        <span>Cipher </span> <span>{{ cert.cipher }}</span>
      </p>
      <p class="is-flex justify-between mb">
        <span>Default Protocol </span> <span>{{ cert.protocol }}</span>
      </p>
      <p class="is-flex justify-between mb">
        <span>Http Clock Skew </span> <span>{{ cert.http_clock_skew }}</span>
      </p>
      <p class="is-flex justify-between mb">
        <span>Last Update </span> <span>{{ cert.updated_at }}</span>
      </p>
    </column>
  </columns> 
</div> 
</template>
<script>
import { mapGetters } from 'vuex'
export default {
  
  beforeCreate() {
    this.$store.dispatch('tlsCertificate/loadCertificateForEnv', this.$route.params.environment)
  },

  computed: {
    ...mapGetters('environment', [
      'environment'
    ]),
    cert() {
      return this.environment.tls_certificate
    }
    
  }
}
</script>